/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Op47_HelpInputs */



/**
* | output |
* | --- |
* | "OP-47 is available for MXF files only." |
*
* @param {Embed_Captions_Local_Op47_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_op47_help = /** @type {((inputs?: Embed_Captions_Local_Op47_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Op47_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("OP-47 est disponible uniquement pour les fichiers MXF.")
	if (locale === "de") return /** @type {LocalizedString} */ ("OP-47 ist nur für MXF-Dateien verfügbar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("OP-47 è disponibile solo per i file MXF.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("OP-47 доступен только для файлов MXF.")
	if (locale === "es") return /** @type {LocalizedString} */ ("OP-47 solo está disponible para archivos MXF.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("OP-47 仅适用于 MXF 文件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("OP-47はMXFファイルのみに対応しています。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("OP-47 केवल MXF फ़ाइलों के लिए उपलब्ध है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O OP-47 está disponível apenas para arquivos MXF.")
	return /** @type {LocalizedString} */ ("OP-47 is available for MXF files only.")
});